module.exports = __webpack_public_path__ + "img/img-advisoryboard1@3x.50b66a0d.jpg";